import styled from 'styled-components'

import Link from 'components/Link'

export const LinkStyled = styled(Link)`
  transition: opacity ${p => p.theme.animation.timeStandard};
  cursor: pointer;
  opacity: 0.4;

  ${p => p.theme.mq.hover} {
    &:hover,
    &.active {
      opacity: 1;
    }
  }
`

export const TextSpan = styled.span``
